import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  data: null,
};
export const slice = createSlice({
  name: "important",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setImportant: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setImportant } = slice.actions;

export default slice.reducer;
